import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import { useNavigate } from "react-router";
import CustomButton from "../../../assets/components/CustomButton";
import CustomRating from "../../../assets/components/CustomRating";
import CrossImg from "../../../assets/images/common/crossGroup.svg";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import toast from "react-hot-toast";
import Loading from "../../../assets/containers/loadingDialog";

function SurveyAlert({ show, handleClose }) {
  const [comment, setComment] = useState("");
  const [commentScore, setcommentScore] = useState("");
  const [loading, setLoading] = useState(false);
  const [ticketId, setTicketId] = useState("");
  const navigate = useNavigate();
  const { quizId } = useSelector(({ quiz }) => quiz);

  useEffect(() => {
    getTicket();
  }, []);

  const getTicket = async () => {
    try {
      setLoading(true);
      await appApi.get(`/quizTicket/getByQuizId/${quizId}`).then(({ data }) => {
        setLoading(false);
        if (data.quizTicket) {
          setTicketId(data.quizTicket._id);
        } else {
          handleClose();
        }
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleSubmitComment = async () => {
    if (comment && commentScore) {
      setLoading(true);
      try {
        await appApi
          .post(`/quiz/comment/create/${quizId}`, {
            comment: comment,
            score: commentScore,
          })
          .then(() => {
            toast.success("با تشکر از شما نظر شما ثبت شد");
            setLoading(false);
            handleClose();
          });
      } catch (error) {
        setLoading(false);
        errorHandler(error);
      }
    } else {
      toast.error("پرکردن تمامی موارد الزامی است");
    }
  };

  const ratingMatchDialog = (
    <div className="w-100 ">
      <img src={CrossImg} alt="check-vector" className={classes.alertBanner} />
      {loading ? (
        <div className="w-100 d-flex justify-content-center align-items-center my-5 py-5 ">
          <Loading size={30} />
        </div>
      ) : (
        <div className={classes.dialogContent}>
          <p className="text-center font-weight-bold">نظر سنجی</p>
          <p className="text-center">
            پایان چالش! دوست داریم نظرت را بدونیم😊:
          </p>
          <textarea
            name="comment"
            placeholder="نظر شما ...."
            className={classes.customTextArea}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
          <div className="text-center mt-3">
            <CustomRating
              value={commentScore}
              handleChagne={(e) => setcommentScore(e.target.value)}
            />
          </div>
          <div className="w-100 mt-4">
            <CustomButton
              clickHandler={handleSubmitComment}
              color={"primary"}
              shadow
              text={"ارسال"}
            />
            <CustomButton
              clickHandler={() => navigate("/leaderboard")}
              color={"secondary"}
              shadow
              styles={{ marginTop: "16px" }}
              text={"جدول پیشتازان"}
            />
          </div>
        </div>
      )}
    </div>
  );
  return (
    <CustomModal
      open={show}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={ratingMatchDialog}
    />
  );
}

export default SurveyAlert;
